import { render, staticRenderFns } from "./event-info-cmp.vue?vue&type=template&id=30f9e5d6&scoped=true"
import script from "./event-info-cmp.vue?vue&type=script&lang=js"
export * from "./event-info-cmp.vue?vue&type=script&lang=js"
import style0 from "./event-info-cmp.vue?vue&type=style&index=0&id=30f9e5d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f9e5d6",
  null
  
)

export default component.exports